import type { PaladinErrorCode } from "@paladin/errors";
import type { i18nKey } from "@paladin/i18n";

/**
 * Map a PaladinErrorCode to the matching i18nKey for displaying the error message on the frontend
 */
export const serverErrorToI18n = (serverError: PaladinErrorCode) => {
  switch (serverError) {
    case "VALIDATION_FAILED":
    case "PERMISSIONS_FAILED":
    case "APPOINTMENT_ALREADY_BOOKED_BY_COLLABORATOR":
    case "BOOKING_SLOT_NO_LONGER_AVAILABLE":
    case "VISIT_BOOKING_SLOT_NOT_ALLOWED_FOR_NON_MEDICAL_STAFF":
    case "EMAIL_NOT_AVAILABLE":
    case "FIELD_LOCKED_BY_HRIS":
    case "PHONE_NUMBER_REQUIRED":
    case "CONFLICTING_BOOKING_SLOT_OF_ANOTHER_TYPE":
    case "CONFLICTING_APPOINTMENT":
    case "CONFLICTING_ACTIVITY":
    case "CONFLICTING_ABSENCE_SLOT":
    case "ABSENCE_SLOT_START_TOO_SOON":
    case "APPOINTMENT_OUTSIDE_OF_BOOKING_SLOT_INTERVAL":
    case "BOOKING_SLOT_CANT_UPDATE_TYPE_IF_APPOINTMENT":
    case "BOOKING_SLOT_CANT_DELETE_IF_APPOINTMENT":
    case "CANT_CREATE_CHECKUP_FOR_NO_SHOW_APPOINTMENT":
    case "CHECKUP_ALREADY_EXISTS_FOR_APPOINTMENT":
    case "APPOINTMENT_INTERVAL_NOT_IN_BOOKING_SLOT_INTERVAL":
    case "APPOINTMENT_START_DATE_IN_THE_PAST":
    case "MEMBERSHIP_NOT_STARTED":
    case "ACTIVITY_START_DATE_IN_THE_PAST":
    case "MISSING_EXPECTED_INFO_FOR_BOOKING":
    case "JOB_TITLE_REQUIRED_FOR_ABSENCE_DECLARATION":
    case "RISK_NOT_FOUND":
    case "RISK_NOT_ASSOCIATED_TO_MEMBER_BRANCH":
    case "INTEGRATION_NOT_FOUND":
    case "INTEGRATION_GENERIC_ERROR":
    case "DOWNLOAD_LINK_EXPIRED":
    case "APPOINTMENT_WITHOUT_DOCUMENTS":
    case "DMST_EXPORT_CONTENTS_CHANGED":
    case "COMPANY_BRANCH_ALREADY_EXISTS":
    case "REPRESENTATIVE_IS_ALREADY_A_PATIENT":
    case "WORK_UNIT_NAME_ALREADY_EXISTS":
    case "WORK_UNIT_LIMIT_REACHED":
    case "WORK_UNIT_RELATION_TARGET_NOT_FOUND":
    case "WEIGHTED_RISK_ALREADY_DECLARED":
    case "WEIGHTED_RISK_WORK_UNIT_NOT_FOUND":
    case "MEDICAL_ATTESTATION_NOT_READABLE":
      return `errors:${serverError}` as const satisfies i18nKey;
    case "FORBIDDEN":
    case "NO_ACCOUNT_ASSOCIATED_TO_THIS_SSO_USER_ERROR":
    case "BAD_CREDENTIALS":
    case "NOT_LOGGED_IN":
    case "PHONE_VERIFICATION_PENDING_REVIEW":
    case "INTERNAL_SERVER_ERROR":
    case "EMPTY_FILE":
    case "TIMEOUT":
      return "errors:DEFAULT_SERVER_ERROR" as const satisfies i18nKey;
    default:
      serverError satisfies never;
      return "errors:DEFAULT_SERVER_ERROR" as const satisfies i18nKey;
  }
};
